/* eslint-disable */

export default (o, c, f) => {
	const saveParse = c.prototype.parse;

	c.prototype.parse = function (cfg) {
		if (cfg?.date === null) {
			cfg.date = new Date(NaN);
		}

		return saveParse.bind(this)(cfg);
	};
};
